import { ForgotPassword } from 'aws-amplify-react';
import React from 'react';
import Button from '../Button';
import ContainerDefault from '../Container';
import Form from '../Form';
import Row from '../Row';
import Section from '../Section';

const Container = ContainerDefault.extend`
    max-width: 20rem;
`;

export default class CustomForgotPassword extends ForgotPassword {
    private sendView() {
        return (
            <div>
                <input autoFocus placeholder="Email" key="username" name="username" onChange={this.handleInputChange} />
                <Button onClick={this.send}>Send Code</Button>
            </div>
        );
    }

    private submitView() {
        return (
            <div>
                <input placeholder="Code" key="code" name="code" autoComplete="off" onChange={this.handleInputChange} />
                <input
                    placeholder="New Password"
                    type="password"
                    key="password"
                    name="password"
                    onChange={this.handleInputChange}
                />
                <Button onClick={this.submit}>Submit</Button>
            </div>
        );
    }

    public render() {
        const { authState } = this.props;

        if (authState !== 'forgotPassword') {
            return null;
        }

        return (
            <Section>
                <Container>
                    <Form>
                        <h3>Forgot Password</h3>
                        {this.state.delivery ? this.submitView() : this.sendView()}
                    </Form>
                    <Row>
                        <Button normal onClick={() => this.changeState('signIn', undefined)}>
                            Back to Sign In
                        </Button>
                    </Row>
                </Container>
            </Section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cognito/CustomForgotPassword.tsx